<template>
  <div class="NotificationsPage">
    <LLPage class="Dashboard">
      <template #breadcrumbs>
        <LLBreadCrumbs :crumbs="crumbs" />
      </template>
      <template #content>
        <UploadProgress></UploadProgress>
        <notifications-page-content />
      </template>
    </LLPage>
  </div>
</template>

<script>
import LLPage from '@/components/layout/LLPage.vue'
import UploadProgress from '@/components/common/UploadProgress.vue'
import LLBreadCrumbs from '@/components/common/ui-components/LLBreadCrumbs.vue'
import NotificationsPageContent from '@/components/pages/notifications/notifications-page-content.vue'

export default {
  name: 'NotificationsPage',
  components: { NotificationsPageContent, LLBreadCrumbs, UploadProgress, LLPage },
  computed: {
    crumbs() {
      return [
        {
          name: this.$t('main_home_label'),
          path: '/'
        },
        {
          name: this.$t('notifications-page.title')
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.NotificationsPage {
}
</style>
